function getExpectedDeliveryDates() {
  const today = new Date()

  let earliestDeliveryDate, latestDeliveryDate, deliveryDate

  const dayOfWeek = today.getDay()

  let extraDaysMondayOne = window.extraDaysMondayOne
  let extraDaysMondayTwo = window.extraDaysMondayTwo
  let extraDaysTuesdayOne = window.extraDaysTuesdayOne
  let extraDaysTuesdayTwo = window.extraDaysTuesdayTwo
  let extraDaysWednesdayOne = window.extraDaysWednesdayOne
  let extraDaysWednesdayTwo = window.extraDaysWednesdayTwo
  let extraDaysThursdayOne = window.extraDaysThursdayOne
  let extraDaysThursdayTwo = window.extraDaysThursdayTwo
  let extraDaysFridayOne = window.extraDaysFridayOne
  let extraDaysFridayTwo = window.extraDaysFridayTwo
  let extraDaysSaturday = window.extraDaysSaturday
  let extraDaysSunday = window.extraDaysSunday

  switch (dayOfWeek) {
    case 1:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysMondayOne * 24 * 60 * 60 * 1000)
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysMondayTwo * 24 * 60 * 60 * 1000)
      }
      break
    case 2:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysTuesdayOne * 24 * 60 * 60 * 1000)
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysTuesdayTwo * 24 * 60 * 60 * 1000)
      }
      break
    case 3:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysWednesdayOne * 24 * 60 * 60 * 1000)
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysWednesdayTwo * 24 * 60 * 60 * 1000)
      }
      break
    case 4:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysThursdayOne * 24 * 60 * 60 * 1000)
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysThursdayTwo * 24 * 60 * 60 * 1000)
      }
      break
    case 5:
      if (today.getHours() < 15) {
        deliveryDate = new Date(today.getTime() + extraDaysFridayOne * 24 * 60 * 60 * 1000)
      } else {
        deliveryDate = new Date(today.getTime() + extraDaysFridayTwo * 24 * 60 * 60 * 1000)
      }
      break
    case 6:
      deliveryDate = new Date(today.getTime() + extraDaysSaturday * 24 * 60 * 60 * 1000)
      break
    case 0:
      deliveryDate = new Date(today.getTime() + extraDaysSunday * 24 * 60 * 60 * 1000)
      break
    default:
      break
  }

  const options = { day: "numeric", month: "long" }
  /*
  const earliestDeliveryStr = earliestDeliveryDate.toLocaleDateString(window.theme.lang, options)
  const latestDeliveryStr = latestDeliveryDate.toLocaleDateString(window.theme.lang, options)
  */
  const deliveryStr = deliveryDate.toLocaleDateString(window.theme.lang, options)

  return `${deliveryStr}`
}
